import { useDialog } from '@rich-products-corp/primitives-richproducts';
import { SignInDialog, SignInDialogProps } from '../../../components/common/dialogs/sign-in.dialog';

export function useSignInDialog(props: SignInDialogProps) {
  return useDialog(<SignInDialog {...props} />);
}
